import { useState } from "react";
import { submitToHubspot } from "../utils/hubspot";

const NEWSLETTER_GUID = "166d60db-7946-4176-8b61-4feb67946efc";

export default function NewsletterForm() {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("idle"); // idle | loading | success | error
    const [errorMessage, setErrorMessage] = useState("");

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setStatus("loading");
        setErrorMessage("");

        try {
            await submitToHubspot(NEWSLETTER_GUID, [
                { name: "email", value: email },
            ]);
            setStatus("success");
            setEmail("");
        } catch (error) {
            setStatus("error");
            setErrorMessage(error instanceof Error ? error.message : "An unknown error occurred.");
        }
    };

    if (status === "success") {
        return <p className="text-green-600">Thank you for subscribing to our newsletter!</p>;
    }

    return (
        <form className="newsletter-form" onSubmit={handleSubmit} noValidate>
            <div>
                <input 
                    type="email" 
                    placeholder="Your email address" 
                    required
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={status === "loading"}
                    value={email}
                    id="newsletter-email"
                />
            </div>
            {status === "error" && (
                <p role="alert" className="text-red-600 mt-2">{errorMessage}</p>
            )}
                <button type="submit" className="btn btn-primary" disabled={status ==="loading"}>
                    {status === "loading" ? "Subscribing..." : "Subscribe"}
                </button>
        </form>
    )
}